const ITEMS = ["Voice Tasking", "Smart Reminders", "Calendar Sync", "Task Delegation", "Gmail Integration", "Appointments", "Contacts", "Alarms", "Today View"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-emerald-900/10 bg-[#F0F5F2] py-5" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-heading text-lg font-bold tracking-tight text-[#1B4D3E]/80">{t}</span>
            <span className="font-serif-accent text-xl italic text-[#2E7D5B]/60">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
